import React from 'react';
import { useTranslation } from 'react-i18next';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const containerStyle = { width: '100%', height: '220px' };

// The city name (position.placeName) is resolved server-side and arrives in the summary,
// so the browser never calls Google's geocoder directly. Falls back to coordinates.
export default function LiveMapCard({ position, live }) {
  const { t } = useTranslation();
  const { isLoaded } = useJsApiLoader({ googleMapsApiKey: GOOGLE_MAPS_API_KEY });

  if (!position) {
    return <div className="rounded-xl border bg-white p-4 text-sm text-gray-500">{t('ownerTelematics.map.waiting')}</div>;
  }

  const center = { lat: position.lat, lng: position.lng };
  const speed = Math.round(position.speedKmh || 0);
  const statusLabel = position.parked ? t('ownerTelematics.map.parked') : t('ownerTelematics.map.moving');
  const place = position.placeName || `${position.lat.toFixed(4)}, ${position.lng.toFixed(4)}`;

  return (
    <div className="overflow-hidden rounded-xl border bg-white">
      {isLoaded ? (
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={14} options={{ disableDefaultUI: true }}>
          <Marker position={center} />
        </GoogleMap>
      ) : (
        <div style={containerStyle} className="flex items-center justify-center text-gray-400">…</div>
      )}
      <div className="flex items-center justify-between p-3 text-sm text-gray-700">
        <span>{[place, `${speed} km/h`, statusLabel].filter(Boolean).join(' · ')}</span>
        <span className={`rounded-full px-2 py-0.5 text-xs ${live ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
          {live ? t('ownerTelematics.map.live') : t('ownerTelematics.map.offline')}
        </span>
      </div>
    </div>
  );
}
